import { useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';

import { clamp } from 'utils/helpers';

export default function useAnimateTextPath(
  scrollOffset,
  isMobileDevice,
  inView
) {
  let distance = useRef(0);
  let scrollPos = useRef(0);
  let startOffset = useRef(0);
  let animationFrameId = useRef(null);

  useEffect(() => {
    const interpolate = 15;

    const textPath = document.querySelector('.animate-path');
    const textPathOutline = document.querySelector('.animate-path-outline');

    const scroll = () => {
      scrollPos.current =
        (window.pageYOffset || document.documentElement.scrollTop) -
        scrollOffset;
    };

    const animateTextPath = () => {
      distance.current = scrollPos.current - startOffset.current;
      startOffset.current += distance.current / interpolate;

      const value = clamp(startOffset.current, -200, 400);

      textPath.setAttribute('startOffset', value);
      textPathOutline.setAttribute('startOffset', value);

      animationFrameId.current = requestAnimationFrame(animateTextPath);
    };

    const throttleScroll = throttle(scroll, 100);

    if (inView && !isMobileDevice()) {
      animationFrameId.current = requestAnimationFrame(animateTextPath);
      window.addEventListener('scroll', throttleScroll);
    }

    return () => {
      cancelAnimationFrame(animationFrameId.current);

      throttleScroll.cancel();
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [inView, isMobileDevice, scrollOffset]);
}
